import React from 'react';

import {Districts} from './components/Districts';
import {DistrictsProps} from './types';

export function DistrictSelection({flowType}: DistrictsProps) {
	return <Districts flowType={flowType} />;
}
